module.exports = __webpack_public_path__ + "img/swiperImg_algorithm.e72d896a.png";